/**
 * MeiliSearch query building shared by the deposits list and the widgets that
 * mirror it. Keeping these here means a card's numbers cannot drift from the
 * list it links to.
 */

/** URL query parameters the deposits list round-trips. */
export const DEPOSITS_QUERY_PARAMS = {
  period: 'period',
  currency: 'currency'
} as const

export type DepositsQueryParam =
  (typeof DEPOSITS_QUERY_PARAMS)[keyof typeof DEPOSITS_QUERY_PARAMS]

/** Matches deposits whose rate range covers the given period, in months. */
export const buildPeriodFilter = (period: string | number, currencyId?: number) => {
  const baseCondition = `(rates.period_from <= ${period} AND rates.period >= ${period})`

  return currencyId ? `(${baseCondition} AND rates.currency_id = ${currencyId})` : baseCondition
}

/** Matches deposits offered in the given currency, by lowercase code. */
export const buildCurrencyFilter = (code: string) => `settings.is_${code} = true`

/**
 * The list's result ordering. Promoted entries come first, then the best rate —
 * per-currency when one is selected, since that is the rate the user compares.
 */
export const buildDepositsSort = (currency?: string) => {
  const bestRateValueSort = currency
    ? `settings.best_rate_value_${currency}:desc`
    : 'settings.best_rate_value:desc'

  return ['weight:desc', 'highlight:desc', bestRateValueSort, 'updated_at:desc']
}
